import * as React from 'react';
import {Audit, Certification, Project} from '../../../../store/projects/commonTypes';
import {
    certificationStatusOptions,
    dateTimeFormatter,
    dateTimeGetter,
    formatDate,
    formatDateTime
} from '../../../../utils/utils';
import {ProjectStatus} from '../../../../store/projects/commonTypes';
import {getOptionLabel, projectStatusOptions} from '../../../../utils/utils';
import {DataGrid, GridCellParams, GridColDef} from '@mui/x-data-grid';
import {Button, Link} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import Stack from "@mui/material/Stack";
import SecurableDownloadLink from "../../../application/SecurableDownloadLink";
import {Assignment, FilePresent, WorkspacePremium} from "@mui/icons-material";
import {User} from "oidc-client";

export interface ProjectAssessmentsProps {
    certifications: Certification[];
    onOpenCertification: (certificationId: string) => void;
    onOpenNewUploadForm: () => void;
    allowToAddReport: boolean;
    user: User;
    showError: (error) => void;
}

export default class ProjectAssessments extends React.Component<ProjectAssessmentsProps> {
    public render() {
        const columns: GridColDef[] = [
            {
                field: 'phase', headerName: 'Revisjonsfase', width: 200,
                renderCell: (params: GridCellParams) => (
                    <Link href="#" onClick={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                        e.preventDefault();
                        this.props.onOpenCertification((params.row as Certification).id);
                    }
                    }>{params.formattedValue}</Link>
                ),
            },
            {field: 'certificationLevelResult', headerName: 'Serifiseringsnivå resultat', width: 200},
            {field: 'certificationScoreResult', headerName: 'Oppnådde poeng', width: 150},
            {
                field: 'created',
                headerName: 'Dato opprettet',
                width: 150,
                valueGetter: dateTimeGetter,
                valueFormatter: dateTimeFormatter
            },
            {
                field: 'modified',
                headerName: 'Siste endringer',
                width: 150,
                valueGetter: dateTimeGetter,
                valueFormatter: dateTimeFormatter
            },
            {field: 'status', headerName: 'Status', width: 150, renderCell: (params: GridCellParams) => getOptionLabel(certificationStatusOptions, (params.row as Certification).certificationStatus)},  
            {
                field: '',
                headerName: 'Sertifikat',
                width: 100,
                renderCell: (params: GridCellParams) => (params.row as Certification).certificationInternalLink && (

                    <SecurableDownloadLink user={this.props.user}
                                           tooltip={"Sertifikat"}
                                           showError={error => this.props.showError(error)}
                                           path={`/api/certification/${(params.row as Certification).id}/certificate`}><WorkspacePremium/></SecurableDownloadLink>
                )
            }
        ];

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-6 d-flex align-items-center mb-3">
                        <h4>QA-prosesser</h4>
                    </div>
                    {this.props.allowToAddReport && (
                        <div className="col-sm-6 d-flex align-items-center justify-content-end mb-3">
                            <Button
                                color="primary"
                                variant="contained"
                                onClick={(event: React.MouseEvent<HTMLButtonElement, Event>) => this.props.onOpenNewUploadForm()}
                                startIcon={<AddIcon/>}
                            >
                                Legg til S&R
                            </Button>
                        </div>
                    )}
                </div>
                <div className="table-container">
                    <DataGrid columns={columns} rows={this.props.certifications} hideFooter hideFooterPagination
                              autoHeight disableSelectionOnClick={true}/>
                </div>
            </React.Fragment>
        );
    }
}